<template>
  <div class="">
    <div class="card-body">
      <form @submit.stop.prevent="exportDebts">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label for="debt_statuses2" class="col-form-label">Статус</label>
              <select class="form-control form-control-sm" id="debt_statuses2" v-model="filter.status_id">
                <option selected="true" value="">{{ $t('field.any') }}</option>
                <option v-for="status in debt_statuses" :value="status.id" :key="status.id">
                  {{ status.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="col-form-label">{{ $t('users.user') }}</label>
              <select class="form-control form-control-sm" v-model="filter.user_id">
                <option selected="true" value="">{{ $t('field.any') }}</option>
                <option v-for="user in users" :value="user.id" :key="user.id">
                  {{ user.lastname }} {{ user.firstname }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="col-form-label">{{ $t('field.contragent') }}</label>
              <select class="form-control form-control-sm" v-model="filter.contragent_id">
                <option selected="true" value="">{{ $t('field.any') }}</option>
                <option v-for="contragent in contragents" :value="contragent.id" :key="contragent.id">
                  {{ contragent.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="col-form-label">Период импорта в базу</label>
              <div class="input-group input-group-sm">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="datestart">C</span>
                </div>
                <input type="date" class="form-control" aria-label="Small" v-model="filter.period_imported_start_date"
                       aria-describedby="datestart"/>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="col-form-label">Период импорта в базу</label>
              <div class="input-group input-group-sm">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="dateend">По</span>
                </div>
                <input type="date" class="form-control" aria-label="Small" v-model="filter.period_imported_end_date"
                       aria-describedby="dateend"/>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="col-form-label">Экпортировать</label>
              <select class="form-control form-control-sm" v-model="archive">
                <option selected="true" value="">{{ $t('field.any') }}</option>
                <option value="with_archive">Вместе с архивом</option>
                <option value="archive">Только архив</option>
              </select>
            </div>
          </div>
        </div>

        <div class="block block-rounded block-fx-shadow">
          <div class="block-content row">
            <div class="col">
              <div class="custom-control custom-checkbox my-1 mr-sm-2">
                <input
                    type="checkbox"
                    @click="toggleSelectAll()"
                    class="custom-control-input"
                    v-model="select_all"
                    id="select_all">
                <label
                    class="custom-control-label"
                    for="select_all"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Выделить все">
                  Поля для заголовка
                </label>
              </div>

              <div class="custom-control custom-checkbox my-1 mr-sm-2" v-for="field in fields" :key="`debts_field_${field}`">
                <input
                    :id="`debts_field_${field}`"
                    type="checkbox"
                    class="custom-control-input"
                    :class="{'is-invalid': errors.fields && errors.fields.length > 0}"
                    v-model="filter.fields"
                    :value="field">
                <label
                    class="custom-control-label"
                    :for="`debts_field_${field}`">
                  {{ $t(`debts.${field}`)}}
                </label>
              </div>
            </div>
          </div>
        </div>

        <button type="submit" class="btn btn-primary" name="button" :disabled="isProcessing">
          <i class="fa fa-spinner fa-pulse fa-fw" v-if="isProcessing"></i> Выгрузить
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import downloader from 'js-file-download';

export default {
  data() {
    return {
      debt_statuses: [],
      users: [],
      contragents: [],
      filename: '',
      select_all: 0,
      filter: {
        status_id: '',
        contragent_id: '',
        user_id: '',
        period_imported_start_date: moment().startOf('month').format('YYYY-MM-DD'),
        period_imported_end_date: moment().endOf('month').format('YYYY-MM-DD'),
        with_archive: 0,
        archive: 0,
        fields: [
          'debtor_iin',
          'number',
          'contragent.name',
          'current_arrears',
          'status_id',
          'transfer_date',
        ]
      },
      fields: [
        'user.login',
        'user.fullname',
        'contragent.name',
        'status.name',
        'debtor.fullname',
        'debtor_iin',
        'number',
        'team',
        'start_date',
        'end_date',
        'delay_credit_day',
        'filial',
        'current_arrears',
        'amount_rewards',
        'amount_credit',
        'loading_current_arrears',
        'registry_date',
        'registry_number',
        'transfer_date',
        'transfer_date_only_date',
        'last_contact',
        'step',
        'debtor.address',
      ],
      errors: {},
      archive: '',
      isProcessing: false,
    };
  },
  mounted() {
    this.getDebtStatuses();
    this.getListUsers();
    this.getListContragents();
  },
  methods: {
    exportDebts() {
      this.isProcessing = true;
      window.axios.post('/admin/export/debts', this.filter, {
        responseType: 'arraybuffer',
      })
        .then((res) => {
          downloader(res.data, 'debts.xlsx')
        })
        .catch((err) => {
          this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    getDebtStatuses() {
      window.axios.get('/admin/list/debt/statuses')
        .then((res) => {
          this.debt_statuses = res.data.statuses;
        });
    },

    getListUsers() {
      window.axios.get('/admin/list/users')
        .then((res) => {
          this.users = res.data.users;
        });
    },
    getListContragents() {
      window.axios.get('/admin/list/contragents')
        .then((res) => {
          this.contragents = res.data.contragents;
        });
    },
    toggleSelectAll() {
      if (this.select_all) {
        this.filter.fields = [];
      } else {
        this.fields.forEach((field) => {
          if (!this.filter.fields.includes(field)) {
            this.filter.fields.push(field)
          }
        });
      }
    },
  },
  watch: {
    archive(value) {
      if (value === 'with_archive') {
        this.filter.with_archive = 1;
        this.filter.archive = 0;
      } else if (value === 'archive') {
        this.filter.with_archive = 0;
        this.filter.archive = 1;
      } else {
        this.filter.with_archive = 0;
        this.filter.archive = 0;
      }
    },
    'filter.fields'() {
      this.select_all = this.filter.fields.length === this.fields.length
    },
    errors(value) {
      if (value.fields && value.fields.length > 0) {
        window.Swal.fire('', 'Выберите хотя бы одно из этих полей', 'error')
      }
    }
  }
};
</script>
